// 侧栏底部存储进度条 —— 数据源 dashboardSummary.storage (F57)
// quotaBytes = null → 未配置配额（R2 unlimited 或后端未落库），只显示已用量、进度条走 100% 灰色

import { useDashboardSummary } from '../lib/dashboard.js';

export function StorageMeter() {
  const q = useDashboardSummary();
  const storage = q.data?.storage;
  const usedBytes = storage?.usedBytes ?? 0;
  const quotaBytes = storage?.quotaBytes ?? null;
  const loading = q.isLoading;

  const configured = quotaBytes != null && quotaBytes > 0;
  const percent = configured ? Math.min(100, (usedBytes / quotaBytes) * 100) : 100;
  const usedText = loading ? '…' : formatBytes(usedBytes);

  if (!loading && !configured) {
    // 未配置配额：只展示已用，进度条 100% 灰色
    return (
      <div>
        <div className="text-xs text-slate-500 dark:text-slate-400 whitespace-nowrap">
          存储使用情况
        </div>
        <div className="mt-1 text-xs">
          <span className="font-medium text-slate-700 dark:text-slate-200 whitespace-nowrap">
            未配置配额，已用 {usedText}
          </span>
        </div>
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
          <div
            className="h-full rounded-full bg-slate-300 dark:bg-slate-600"
            style={{ width: '100%' }}
          />
        </div>
      </div>
    );
  }

  const quotaText = configured ? formatBytes(quotaBytes) : '—';

  return (
    <div>
      <div className="text-xs text-slate-500 dark:text-slate-400 whitespace-nowrap">
        存储使用情况
      </div>
      <div className="mt-1 flex items-baseline justify-between text-xs">
        <span className="font-medium text-slate-700 dark:text-slate-200 whitespace-nowrap">
          {usedText} / {quotaText}
        </span>
        <span className="text-slate-500 dark:text-slate-400 tabular-nums">
          {percent.toFixed(1)}%
        </span>
      </div>
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
        <div
          className="h-full rounded-full bg-brand-500 transition-all"
          style={{ width: `${String(percent)}%` }}
        />
      </div>
    </div>
  );
}

function formatBytes(n: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v >= 100 ? 0 : v >= 10 ? 1 : 2)} ${units[i] ?? 'B'}`;
}
